import { Controller } from "@hotwired/stimulus"

// A period preset select paired with start/end date fields. Preset periods fill the dates on the
// server; editing a date by hand switches the select to the custom period so the dates are used.
export default class extends Controller {
  static targets = ["period"]
  static values = { custom: { type: String, default: "custom" } }

  dateChanged() {
    this.periodTarget.value = this.customValue
  }
}
